$(document).on("change","#no-receipt",async function(){
    const isChecked = ($(this).is(":checked")) ? 'yes' : '';

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            ["No Receipt"]: isChecked
          }
        })
      });

      console.log('Cart attribute updated:', isChecked);
    } catch (error) {
      console.error('Error updating cart attribute:', error);
    }
});

$(".hasSubMenuitems").on("click",function(){
  $(this).toggleClass("active");
  $(this).siblings("ul").toggle();
  if($(this).hasClass("active"))
  {
    $(this).find(".icon-mius").show();
    $(this).find(".icon-plus").hide();
  }
  else
  {
    $(this).find(".icon-mius").hide();
    $(this).find(".icon-plus").show();
  }
});